import './managerTableView.scss';

export const MTV_CLASSES = {
    faExclamationTriangle: 'mtv-fa-exclamation',
    transparentButton: 'mtv-transparent-button',
    transparentButtonNoPadding: 'mtv-transparent-button-no-padding',
    buttonAddMore: 'mtv-button-add-more',
    labelButtons: 'mtv-label-buttons',
    labelViews: 'mtv-label-views',
    fixPadding: 'mtv-fix-padding',
    shiftTimeTextLarge: 'mtv-shift-time-text-large',
    employeeNameText: 'mtv-employee-name-text',
    SSShiftCard: 'mtv-ss-shift-card',
    VTOShiftCard: 'mtv-vto-shift-card',
    VTOShiftCardApproved: 'mtv-vto-shift-card-approved',
    iconFixHeight: 'mtv-icon-fix-height',
    selectWrapper: 'mtv-select-wrapper',
    moreOptionsButton: 'mtv-more-options-button',
    dataviewTableGroup: 'mtv-dv-table-group',
    dataviewTableGroupHeader: 'mtv-dv-table-group-header',
    dataviewTableGroupHeaderShift: 'mtv-dv-table-group-header-shift',
    dataviewTableSegmentInfos: 'mtv-dv-table-segment-infos',
    dataviewTableRecalculateAwarding: 'mtv-dv-table-recalculate-awarding',
    dataviewTableToggleButton: 'mtv-dv-table-toggle-button',
    SideBarTitle: 'mtv-sidebar-title',
    plusMinus: 'mtv-plus-minus',
    // Chip classes no longer needed - RequestTypeChip now uses its own SCSS
    chipTC: 'chip-tc',
    chipSS: 'chip-ss',
    chipOS: 'chip-os',
    chipVTO: 'chip-vto',
};
